import SendGlimpse from './send_glimpse'
import { connect } from 'react-redux'
import { destroy } from 'redux-form'
import { inflateUserTxns } from 'redux/modules/user_txns'
import { getStepName } from 'lib/route_utils'
import isOwnerSelector from 'redux/selectors/is_owner'
import { resetIsReturningFromWallet } from 'redux/modules/server'

const mapStateToProps = (state, props) => {
  return {
    showSpinner: state.send_iframe.iframe_loading,
    inSuccess:
      getStepName('send', props.routes) === 'review' &&
      state.send_iframe.send_done,
    isOwner: isOwnerSelector(state, props),
    isReturningFromWallet: state.server.isReturningFromWallet,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onUnmount() {
      // This is here (and not in the route's onLeave) because of lifecycle cosiderations. The onLeave callback
      // is called before everything is unmounted, so if we clear the form (and other things)
      // when before the send flow's components are unmounted, they will do unneccsary update, or worse -
      /// they will do updates with null (or undefined) values.
      dispatch(destroy('send'))
      dispatch(resetIsReturningFromWallet())
      dispatch(inflateUserTxns(campaignId))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendGlimpse)
